import { IRoute } from '../models';

import { TRouteAction, RouteActionTypes } from '@/store/types/route.types';

export const setRoute = (route: IRoute): TRouteAction => ({
  type: RouteActionTypes.SET_ROUTE,
  shouldSkipToaster: true,
  route,
});

export const setRouteTitle = (title: string): TRouteAction => ({
  type: RouteActionTypes.SET_ROUTE_TITLE,
  shouldSkipToaster: true,
  title,
});

export const setRoutePath = (path: string): TRouteAction => ({
  type: RouteActionTypes.SET_ROUTE_PATH,
  shouldSkipToaster: true,
  path,
});
